module.exports = {
  filterAjaxList: [
    {
      url: '/api/label/brand/label',
      method: 'post',
      param: {},
      flagKey: 'brand',
      id: 'name',
      name: 'name',
      isLimit: true
    },
    {
      url: '/api/label/line/label',
      method: 'get',
      flagKey: 'lineName',
      id: 'name',
      name: 'name',
      isLimit: true
    },
    {
      url: '/api/label/platform/label',
      method: 'post',
      param: {},
      flagKey: 'platform',
      id: 'name',
      name: 'name',
      isLimit: true
    },
    {
      url: '/api/label/content/type/label',
      method: 'get',
      param: {},
      flagKey: 'contentType',
      id: 'name',
      name: 'name',
      isLimit: true
    },
    {
      url: '/api/label/scene/label',
      method: 'get',
      param: {},
      flagKey: 'scene',
      id: 'name',
      name: 'name',
      isLimit: true
    },
    {
      url: '/api/label/theme/label',
      method: 'get',
      param: {},
      flagKey: 'theme',
      id: 'name',
      name: 'name',
      isLimit: true
    },
    {
      url: '/api/label/cover/label',
      method: 'get',
      param: {},
      flagKey: 'cover',
      id: 'name',
      name: 'name',
      isLimit: true
    },
    {
      url: '/api/label/total/cost/label',
      method: 'get',
      param: {},
      flagKey: 'totalCostLevel',
      id: 'name',
      name: 'name',
      isLimit: true
    },
    {
      url: '/api/label/cpe/label',
      method: 'get',
      param: {},
      flagKey: 'cpeCostLevel',
      id: 'name',
      name: 'name',
      isLimit: true
    },
    {
      url: '/api/label/cpv/label',
      method: 'get',
      param: {},
      flagKey: 'cpvCostLevel',
      id: 'name',
      name: 'name',
      isLimit: true
    },
    {
      url: '/api/label/auth/circle/label',
      method: 'get',
      param: {},
      flagKey: 'authCircle',
      id: 'name',
      name: 'name',
      isLimit: true
    },
    {
      url: '/api/label/follower/level/label',
      method: 'get',
      param: {},
      flagKey: 'followerLevel',
      id: 'name',
      name: 'name',
      isLimit: true
    },
    {
      url: '/api/label/auth/level/label',
      method: 'get',
      param: {},
      flagKey: 'authLevel',
      id: 'name',
      name: 'name',
      isLimit: true
    },
    {
      url: '/api/label/area/label',
      method: 'get',
      param: {},
      flagKey: 'autoArea',
      id: 'name',
      name: 'name'
    },
    {
      url: '/api/label/is/prereport/label',
      method: 'get',
      flagKey: 'isPrereport',
      isLimit: true,
      id: 'name',
      name: 'name'
    }
  ],
  filterForm: [
    {
      type: 'input',
      placeholder: '请您输入想要搜索的关键词，多个关键词用空格或逗号分开，非必填',
      id: 'title',
      label: '内容标题',
      width: '60%',
      intValue: ''
    },
    {
      type: 'input',
      placeholder: '请您输入想要搜索的URL链接，非必填',
      id: 'url',
      label: '发布链接',
      width: '60%',
      intValue: ''
    },
    {
      type: 'input',
      placeholder: '请您输入想要搜索的关键词，多个关键词用空格或逗号分开，非必填',
      id: 'authName',
      label: '达人名称',
      width: '60%',
      intValue: ''
    },
    {
      type: 'radioDate',
      clearable: true,
      id: 'pubDate',
      label: '发布日期',
      width: '100%',
      intValue: '',
      isShowChooseDate: false,
      defineDateVal: '',
      children: [
        {
          id: '',
          name: '不限'
        }, {
          id: '7',
          name: '近一周'
        }, {
          id: '30',
          name: '近一个月'
        }, {
          id: '90',
          name: '近三个月'
        }, {
          id: '180',
          name: '近半年'
        }, {
          id: '365',
          name: '近一年'
        }, {
          id: 'define',
          name: '自定义'
        }
      ]
    },
    {
      label: '产品维度',
      width: '60px'
    },
    {
      type: 'select',
      clearable: true,
      id: 'platform',
      label: '来源平台',
      width: '250px',
      intValue: '',
      children: [
        {
          id: '',
          name: '不限'
        }
      ]
    },
    {
      type: 'select',
      clearable: true,
      id: 'brand',
      label: '品牌',
      width: '250px',
      intValue: '',
      children: [
        {
          id: '',
          name: '不限'
        }
      ]
    },
    {
      type: 'select',
      clearable: true,
      id: 'lineName',
      label: '产线',
      width: 'calc(100% - 640px)',
      intValue: '',
      children: [
        {
          id: '',
          name: '不限'
        }
      ]
    },
    {
      label: '内容维度',
      width: '60px'
    },
    {
      type: 'select',
      clearable: true,
      id: 'contentType',
      label: '内容类型',
      width: '250px',
      intValue: '',
      children: [
        {
          id: '',
          name: '不限'
        }
      ]
    },
    {
      type: 'select',
      clearable: true,
      id: 'scene',
      label: '内容场景',
      width: '250px',
      intValue: '',
      children: [
        {
          id: '',
          name: '不限'
        }
      ]
    },
    {
      type: 'select',
      clearable: true,
      id: 'theme',
      label: '内容选题',
      width: '250px',
      intValue: '',
      children: [
        {
          id: '',
          name: '不限'
        }
      ]
    },
    {
      type: 'select',
      clearable: true,
      id: 'cover',
      label: '内容封面',
      width: 'calc(100% - 980px)',
      intValue: '',
      children: [
        {
          id: '',
          name: '不限'
        }
      ]
    },
    {
      label: '',
      width: '60px'
    },
    {
      type: 'select',
      clearable: true,
      id: 'isPopular',
      label: '是否爆款',
      width: '250px',
      intValue: '',
      children: [
        {
          id: '',
          name: '不限'
        },
        {
          id: '是',
          name: '是'
        },
        {
          id: '否',
          name: '否'
        }
      ]
    },
    {
      type: 'select',
      clearable: true,
      id: 'isPrereport',
      label: '是否报备',
      width: 'calc(100% - 380px)',
      intValue: '',
      children: []
    },
    {
      label: '费用维度',
      width: '60px'
    },
    {
      type: 'select',
      clearable: true,
      id: 'totalCostLevel',
      label: '费用成本',
      width: '250px',
      intValue: '',
      children: [
        {
          id: '',
          name: '不限'
        }
      ]
    },
    {
      type: 'select',
      clearable: true,
      id: 'cpeCostLevel',
      label: 'CPE',
      width: '250px',
      intValue: '',
      children: [
        {
          id: '',
          name: '不限'
        }
      ]
    },
    {
      type: 'select',
      clearable: true,
      id: 'cpvCostLevel',
      label: 'CPV',
      width: 'calc(100% - 640px)',
      intValue: '',
      children: [
        {
          id: '',
          name: '不限'
        }
      ]
    },
    {
      label: '达人维度',
      width: '60px'
    },
    {
      type: 'select',
      clearable: true,
      id: 'authCircle',
      label: '达人圈层',
      width: '250px',
      intValue: '',
      children: [
        {
          id: '',
          name: '不限'
        }
      ]
    },
    // {
    //   type: 'select',
    //   clearable: true,
    //   id: 'followerLevel',
    //   label: '粉丝量级',
    //   width: '250px',
    //   intValue: '',
    //   children: [
    //     {
    //       id: '',
    //       name: '不限'
    //     }
    //   ]
    // },
    {
      type: 'select',
      clearable: true,
      id: 'authLevel',
      label: '达人量级',
      width: '250px',
      intValue: '',
      children: [
        {
          id: '',
          name: '不限'
        }
      ]
    },
    {
      type: 'tree',
      id: 'autoArea',
      label: '所在地区',
      width: 'calc(100% - 640px)',
      props: {
        value: 'id',
        label: 'name',
        expandTrigger: 'click',
        multiple: false,
        checkStrictly: true
      },
      placeholder: '可输入搜索选择',
      filterable: true,
      clearable: true,
      intValue: ''
    }
  ],
  sortRules: [
    {
      name: '降序',
      id: '1'
    }, {
      name: '升序',
      id: '2'
    }
  ],
  tableBtn: [
    {
      id: 'check',
      name: '查看详情',
      dataStatus: '1',
      isNoConfirm: true // 不需要弹窗询问
    },
    {
      id: 'edit',
      name: '修改数据',
      dataStatus: '1',
      isNoConfirm: true // 不需要弹窗询问
    }
  ],
  tableHead: [
    {
      label: '序号',
      key: '$index',
      width: '60',
      fixed: true
    }, {
      label: '内容标题',
      key: 'title',
      fixed: true,
      isLink: true,
      linkKey: 'url',
      width: '260'
    }, {
      label: '发布链接',
      key: 'url',
      fixed: true,
      isLink: true,
      linkKey: 'url'
    }, {
      label: '发布时间',
      key: 'pubTime',
      width: '150'
    }, {
      label: '发布日期',
      key: 'pubDate'
    }, {
      label: '平台',
      key: 'platform'
    }, {
      label: '品牌',
      key: 'brand',
      width: '150'
    }, {
      key: 'lineName',
      label: '产线'
    }, {
      key: 'lineType',
      label: '产品型号'
    }, {
      key: 'contentType',
      label: '内容类型'
    }, {
      key: 'theme',
      label: '内容选题'
    }, {
      key: 'cover',
      label: '内容封面'
    }, {
      key: 'scene',
      label: '内容场景'
    }, {
      key: 'sellPoint',
      label: '产品卖点'
    }, {
      key: 'productExposeRate',
      label: '产品露出'
    }, {
      key: 'depth',
      label: '内容深度'
    }, {
      key: 'isPrereport',
      label: '是否报备'
    }, {
      key: 'hasPersonalOpinion',
      label: '是否有个人使用后的经验',
      width: '200px'
    }, {
      key: 'exposeNum',
      label: '曝光数'
    }, {
      key: 'readNum',
      label: '阅读量',
      relatedKey: 'interactRate,cpvCost'
    }, {
      key: 'likeNum',
      label: '点赞量',
      relatedKey: 'interactNum'
    }, {
      key: 'subscribeNum',
      label: '收藏量',
      relatedKey: 'interactNum'
    }, {
      key: 'commentNum',
      label: '评论量',
      relatedKey: 'interactNum'
    }, {
      key: 'interactNum',
      label: '互动量',
      relatedKey: 'interactRate,cpeCost',
      noInsert: true
    }, {
      key: 'interactRate',
      label: '互动率',
      noInsert: true
    }, {
      key: 'finishRate',
      label: '完播率'
    }, {
      key: 'isCollect',
      label: '是否收录'
    }, {
      key: 'isPopular',
      label: '是否爆款'
    }, {
      key: 'authName',
      label: '达人名称'
    }, {
      key: 'authCountry',
      label: '国家'
    }, {
      key: 'authProvince',
      label: '省份'
    }, {
      key: 'authCity',
      label: '城市'
    }, {
      key: 'follower',
      label: '粉丝数'
    }, {
      key: 'followerLevel',
      label: '粉丝量级'
    }, {
      key: 'authLikeCollcet',
      label: '获赞与收藏量'
    }, {
      key: 'authLevel',
      label: '达人量级'
    }, {
      key: 'authCircle',
      label: '达人圈层'
    }, {
      key: 'cooperateType',
      label: '合作形式'
    }, {
      key: 'searchCost',
      label: '搜索信息流花费(元)'
    }, {
      key: 'brandAdCost',
      label: '品牌广告花费(元)'
    }, {
      key: 'cooperateCost',
      label: '合作价格(元)'
    }, {
      key: 'totalCost',
      label: '费用成本(元)'
    }, {
      key: 'totalCostLevel',
      label: '费用成本层级'
    }, {
      key: 'cpeCost',
      label: 'CPE(元)',
      noInsert: true,
      relatedKey: 'cpeCostLevel'
    }, {
      key: 'cpeCostLevel',
      label: 'CPE层级'
    }, {
      key: 'cpvCost',
      label: 'CPV(元)'
    }, {
      key: 'cpvCostLevel',
      label: 'CPV层级'
    }, {
      key: 'commentKeyword',
      label: '讨论关键词'
    }, {
      key: 'positiveCommentNum',
      label: '我方正面及中性评论数',
      width: '220px'
    }, {
      key: 'negativeCommentNum',
      label: '我方负面评论数',
      width: '180px'
    }, {
      key: 'competitorPositiveCommentNum',
      label: '竞品正面及中性评论数',
      width: '220px'
    }, {
      key: 'competitorNegativeCommentNum',
      label: '竞品负面评论数'
    }, {
      key: 'founderName',
      label: '创建人'
    }, {
      key: 'founderTime',
      label: '创建时间'
    }, {
      key: 'modifierName',
      label: '修改人'
    }, {
      key: 'updateTime',
      label: '修改时间'
    }
  ]
}
